"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const ScheduledTransactionFormQuicken_1 = __importDefault(require("components/ScheduledTransactions/ScheduledTransactionFormQuicken"));
// eslint-disable-next-line react/function-component-definition
const ScheduledTransactionFormContainer = (props) => {
    const [isConfirmationDialogOpen, setConfirmationDialog] = React.useState(false);
    const [isFormDirty, setDirtyForm] = React.useState(false);
    return (<Dialog_1.default open={Boolean(props.scheduledTransaction)} onClose={() => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, isFormDirty); }} aria-labelledby="edit-recurrence-dialog">
      <ScheduledTransactionFormQuicken_1.default {...props} label={(props.scheduledTransaction || {}).id ? 'Edit Series' : 'Add New Series'} showCloseButton isConfirmationDialogOpen={isConfirmationDialogOpen} showConfirmationDialog={setConfirmationDialog} setDirtyForm={setDirtyForm} isFormDirty={isFormDirty}/>
    </Dialog_1.default>);
};
exports.default = ScheduledTransactionFormContainer;
